import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal } from '../../../../ui';

const Details = ({ styles, content, impressum = undefined }) => {
    function createMarkup() {
        if (impressum) {
            return { __html: impressum };
        }
    }

    const [modalOpen, setModalOpen] = React.useState(false);

    const handleModalChange = e => {
        e.preventDefault();

        if (e.type !== 'keydown') {
            setModalOpen(!modalOpen);
            return;
        }

        setModalOpen(e.key !== 'Escape' && modalOpen);
    };

    return (
        <>
            <div className={styles.addressColumn}>
                <div className={styles.divider} />
                <div>
                    {content.col1.map(item => (
                        <span className={styles.columnLine} key={item.id}>
                            <FormattedMessage id={item.message} />
                        </span>
                    ))}
                </div>
            </div>
            <div className={styles.addressColumn}>
                <div className={styles.divider} />
                <div>
                    {content.col2.map(item => (
                        <span className={styles.columnLine} key={item.id}>
                            <FormattedMessage id={item.message} />
                        </span>
                    ))}
                </div>
            </div>
            <div className={styles.addressColumn}>
                <div className={styles.divider} />
                <div>
                    {content.col3.map(item => (
                        <span className={styles.columnLine} key={item.id}>
                            <FormattedMessage id={item.message} />
                        </span>
                    ))}
                    {impressum ? (
                        <>
                            <span
                                tabIndex="0"
                                onKeyDown={handleModalChange}
                                role="button"
                                onClick={handleModalChange}
                                className={styles.link}
                            >
                                Impressum
                            </span>
                            <Modal open={modalOpen} onOpenChange={open => setModalOpen(open)}>
                                {/* eslint-disable-next-line  react/no-danger*/}
                                <div className={styles.dangerousContainer} dangerouslySetInnerHTML={createMarkup()} />
                            </Modal>
                        </>
                    ) : null}
                </div>
            </div>
        </>
    );
};

Details.propTypes = {
    styles: PropTypes.shape().isRequired,
    content: PropTypes.shape().isRequired,
    impressum: PropTypes.string,
};

export default Details;
